import { CartUpdateEvent } from '@theme/events';

const CHECKOUT_SELECTOR = '#checkout[name="checkout"][form="cart-form"]';
const CART_FORM_SELECTOR = 'form#cart-form';
const MARKER_KEY = 'rolife:checkout-return:pending';
const MARKER_TTL_MS = 30 * 60 * 1000;
const STATE_KEY = Symbol.for('rolife.checkoutReturnCartEventBridge');

globalThis[STATE_KEY]?.abort();

const controller = new AbortController();
globalThis[STATE_KEY] = controller;

function markerStorage() {
  try {
    return globalThis.sessionStorage;
  } catch {
    return null;
  }
}

function markCheckoutDeparture() {
  try {
    markerStorage()?.setItem(MARKER_KEY, String(Date.now()));
  } catch {
    // Storage may be unavailable in privacy-restricted browsing contexts.
  }
}

function consumeFreshCheckoutMarker() {
  const storage = markerStorage();
  if (!storage) return false;

  try {
    const rawMarker = storage.getItem(MARKER_KEY);
    if (rawMarker === null) return false;

    storage.removeItem(MARKER_KEY);

    const markedAt = Number(rawMarker);
    const age = Date.now() - markedAt;

    return Number.isFinite(markedAt) && age >= 0 && age <= MARKER_TTL_MS;
  } catch {
    return false;
  }
}

document.addEventListener(
  'click',
  (event) => {
    if (event.target?.closest?.(CHECKOUT_SELECTOR)) {
      markCheckoutDeparture();
    }
  },
  { capture: true, signal: controller.signal }
);

document.addEventListener(
  'submit',
  (event) => {
    if (
      event.target?.matches?.(CART_FORM_SELECTOR) &&
      event.submitter?.matches?.(CHECKOUT_SELECTOR)
    ) {
      markCheckoutDeparture();
    }
  },
  { capture: true, signal: controller.signal }
);

window.addEventListener(
  'pageshow',
  () => {
    if (!consumeFreshCheckoutMarker()) return;

    queueMicrotask(() => {
      document.dispatchEvent(
        new CartUpdateEvent({}, 'rolife-checkout-return', {
          source: 'rolife-checkout-return',
        })
      );
    });
  },
  { signal: controller.signal }
);
